var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./IssuesCategoryCard.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-17cb5484!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./IssuesCategoryCard.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/issues/IssuesCategoryCard.vue
// module id = 676
// module chunks = 2